<template>
  <div>
    <!-- <h1>{{message}}</h1> -->
    <!-- <element-view></element-view> -->

    <!-- 员工管理 -->
    <!-- <emp-view></emp-view> -->
    <!-- <router-view></router-view> -->
    <!-- <echartsview></echartsview> -->
    <echartsCopy></echartsCopy>
  </div>
</template>

<script>
// import echarts from './views/element/echarts.vue';
// import EmpView from './views/tlias/EmpView.vue'
/* import ElementView from './views/element/ElementView.vue' */
import echartsCopy from './views/element/echartsCopy.vue';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

export default {
  components: { echartsCopy },
  // components: {echartsview /*EmpView*/ /* ElementView */ },
  data() {
    return {
      message: "Hello vue222"
    }
  },
  methods: {
    
  }
}


</script>

<style>
body {
  padding: 0;
  margin: 0;
}
</style>
